// extracted by mini-css-extract-plugin
module.exports = {"root":"Divider_root__1qIql","popup":"Divider_popup__C9xoF","menu":"Divider_menu__avuI0","fadeIn":"Divider_fadeIn__uYPG3","spin":"Divider_spin__9MLWh"};